import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
  output,
} from '@angular/core';
import { WIDGET_RECAPTCHA_V2_HINT_DEFAULT } from '../../constants/checkout-security.constants';
import { WidgetRecaptchaV2ChallengeComponent } from '../widget-recaptcha-v2-challenge/widget-recaptcha-v2-challenge.component';

@Component({
  standalone: true,
  selector: 'ufp-widget-recaptcha-v2-section',
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetRecaptchaV2ChallengeComponent],
  template: `
    <section class="widget-recaptcha-v2-section" aria-live="polite">
      <p class="widget-recaptcha-v2-hint" role="status">{{ hint() }}</p>
      <ufp-widget-recaptcha-v2-challenge
        (resolved)="resolved.emit($event)"
        (failed)="failed.emit()"
      />
    </section>
  `,
  styleUrls: ['../../styles/widget-submit-ui.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetRecaptchaV2SectionComponent {
  readonly hint = input<string>(WIDGET_RECAPTCHA_V2_HINT_DEFAULT);

  readonly resolved = output<string>();
  readonly failed = output<void>();
}
